(() => {
  'use strict';
  if (window.__NH2_UPSELL__) return;
  window.__NH2_UPSELL__ = true;

  const rootPath = window.Shopify?.routes?.root || '/';
  const current = document.querySelector('[data-nh2-current-product]');
  const form = document.querySelector('#nh2-product-form');
  const buybox = document.querySelector('.nh2-buybox');
  if (!current || !form || !buybox || current.dataset.nh2LaunchReady !== 'true') return;

  const handle = current.dataset.nh2Handle || '';
  if (!handle) return;

  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[char]);
  const previewThemeId = new URL(location.href).searchParams.get('preview_theme_id');

  const productJsonUrl = (productHandle) => `${rootPath}products/${encodeURIComponent(productHandle)}.js`;
  const verifiedViewUrl = (productHandle) => {
    const url = new URL(`${rootPath}products/${encodeURIComponent(productHandle)}`, location.origin);
    url.searchParams.set('view', 'nh2-upselldata');
    if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
    return url.toString();
  };

  const fetchJson = async (url) => {
    const response = await fetch(url, { credentials:'same-origin', headers:{ Accept:'application/json' } });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
  };

  const validAccessory = (data) => Boolean(data && data.launchReady === true && data.available === true && data.variantId && data.handle && data.handle !== handle);

  const fetchVerified = async (productHandle) => {
    try {
      const data = await fetchJson(verifiedViewUrl(productHandle));
      return validAccessory(data) ? data : null;
    } catch (_) { return null; }
  };

  const currentVerifiedData = async () => {
    try { return await fetchJson(verifiedViewUrl(handle)); }
    catch (_) { return null; }
  };

  const recommendationHandles = async () => {
    const product = await fetchJson(productJsonUrl(handle));
    if (!product?.id) return [];
    const url = new URL(`${rootPath}recommendations/products.json`, location.origin);
    url.searchParams.set('product_id', String(product.id));
    url.searchParams.set('limit', '4');
    url.searchParams.set('intent', 'complementary');
    const data = await fetchJson(url.toString());
    const products = Array.isArray(data?.products) ? data.products : [];
    return [...new Set(products.map((item) => item?.handle).filter(Boolean))].filter((candidate) => candidate !== handle).slice(0, 4);
  };

  const uniqueAccessories = (items) => {
    const seen = new Set();
    return items.filter((item) => {
      if (!validAccessory(item) || seen.has(item.handle)) return false;
      seen.add(item.handle);
      return true;
    });
  };

  const itemHtml = (item) => `<label class="nh2-upsell-item"><span class="nh2-upsell-item__media">${item.image ? `<img src="${esc(item.image)}" alt="" width="116" height="116" loading="lazy">` : ''}</span><span class="nh2-upsell-item__copy"><strong>${esc(item.title)}</strong><span>${esc(item.price || '')}</span></span><input type="checkbox" value="${esc(item.variantId)}" data-nh2-upsell-check aria-label="Dodaj ${esc(item.title)}"></label>`;

  const buildPanel = (items) => {
    const details = document.createElement('details');
    details.className = 'nh2-upsell';
    details.open = true;
    details.dataset.nh2Upsell = '';
    details.innerHTML = `<summary><span class="nh2-upsell__summary-copy"><span class="nh2-upsell__plus">+</span><strong>Dodaj przydatne akcesoria</strong></span><span class="nh2-upsell__count">${items.length}</span></summary><div class="nh2-upsell__body"><p class="nh2-upsell__hint">Wybierz tylko to, czego potrzebujesz. Wybrane pozycje dodamy razem z produktem.</p><div class="nh2-upsell__items">${items.map(itemHtml).join('')}</div><div class="nh2-upsell__footer"><span data-nh2-upsell-state>Nic nie wybrano</span><strong>1 klik → wspólny koszyk</strong></div><div class="nh2-upsell__error" data-nh2-upsell-error hidden></div></div>`;
    return details;
  };

  const init = async () => {
    const [currentData, recommendedHandles] = await Promise.all([
      currentVerifiedData(),
      recommendationHandles().catch(() => [])
    ]);

    const complementary = (await Promise.all(recommendedHandles.map(fetchVerified))).filter(Boolean);
    const fallback = Array.isArray(currentData?.fallbackAccessories) ? currentData.fallbackAccessories.filter(validAccessory) : [];
    const candidates = uniqueAccessories([...complementary, ...fallback]).slice(0, 4);
    if (!candidates.length) return;

    const panel = buildPanel(candidates);
    const actions = buybox.querySelector('.nh2-product-actions');
    if (actions) buybox.insertBefore(panel, actions);
    else form.insertAdjacentElement('afterend', panel);

    const oldComplements = document.querySelector('.nh2-related--complements');
    if (oldComplements) oldComplements.hidden = true;

    const checks = [...panel.querySelectorAll('[data-nh2-upsell-check]')];
    const state = panel.querySelector('[data-nh2-upsell-state]');
    const error = panel.querySelector('[data-nh2-upsell-error]');
    const addButton = form.querySelector('button[name="add"], button[type="submit"]');
    const originalLabel = addButton?.textContent?.trim() || 'Dodaj do koszyka';

    const selected = () => checks.filter((input) => input.checked).map((input) => String(input.value));
    const paint = () => {
      const count = selected().length;
      if (state) state.textContent = count === 0 ? 'Nic nie wybrano' : count === 1 ? 'Wybrano 1 akcesorium' : `Wybrano ${count} akcesoria`;
      if (addButton && !addButton.disabled) addButton.textContent = count ? `${originalLabel} + ${count} ${count === 1 ? 'akcesorium' : 'akcesoria'}` : originalLabel;
      if (error) error.hidden = true;
    };
    checks.forEach((input) => input.addEventListener('change', paint));
    paint();

    form.addEventListener('submit', async (event) => {
      const accessoryIds = selected();
      if (!accessoryIds.length) return;
      const purchaseState = document.querySelector('[data-nh2-purchase-state]');
      if (purchaseState?.dataset.launchReady !== 'true') return;

      const formData = new FormData(form);
      const mainVariantId = String(formData.get('id') || '');
      if (!mainVariantId) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      panel.classList.add('is-adding');
      if (error) error.hidden = true;
      if (addButton) { addButton.disabled = true; addButton.textContent = 'Dodaję produkt i akcesoria…'; }

      const quantity = Math.max(1, Number(formData.get('quantity') || 1));
      const items = [{ id:Number(mainVariantId), quantity }].concat(accessoryIds.map((id) => ({ id:Number(id), quantity:1 })));

      try {
        const response = await fetch(`${rootPath}cart/add.js`, {
          method:'POST',
          credentials:'same-origin',
          headers:{ 'Content-Type':'application/json', Accept:'application/json' },
          body:JSON.stringify({ items })
        });
        if (!response.ok) {
          let message = 'Nie udało się dodać wszystkich pozycji do koszyka.';
          try { const data = await response.json(); message = data?.description || data?.message || message; } catch (_) {}
          throw new Error(message);
        }
        location.href = `${rootPath}cart`;
      } catch (err) {
        panel.classList.remove('is-adding');
        if (addButton) { addButton.disabled = false; paint(); }
        if (error) { error.textContent = err?.message || 'Nie udało się dodać zestawu. Spróbuj ponownie.'; error.hidden = false; }
      }
    }, true);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
